/** @jsx jsx */
import { jsx, css } from '@emotion/core';

import React from 'react';
import Buttons from '../../buttons';
import Grid from '@material-ui/core/Grid';
import useContentMgmt from '../../../hooks/useContentMgmt';
import microcopyGroupIds from '../microcopyGroupIds';
import { navigate } from '@reach/router';

export type ProceedOrCancelButtonProps = {
  back?: string | false;
  backRouteState?: any;
  next?: boolean;
  isCancel?: boolean | false;
  nextLabel?: string;
  backLabel?: string;
  disable?: boolean | false;
  handleClickBack?: () => void;
};

const ProceedOrCancelButton = ({
  back,
  backRouteState,
  next = true,
  isCancel,
  nextLabel = '',
  backLabel = '',
  disable = false,
  handleClickBack,
}: ProceedOrCancelButtonProps) => {
  const { content } = useContentMgmt(microcopyGroupIds.PGE_PLUS_REUSABLE_SLUGS);

  const handleBackClick = () => {
    window.history.back();
  };

  return (
    <Grid
      container
      spacing={2}
      css={{
        marginTop: 24,
        marginBottom: 24,
        justifyContent: 'center',
        ...((!back && isCancel) || !next
          ? {
              display: 'flex',
              justifyContent: 'center',
            }
          : {}),
      }}
    >
      {(back || handleClickBack) && (
        <Grid item xs={6} md={3}>
          <Buttons
            type="button"
            fullWidth
            variant="outlined"
            color="secondary"
            onClick={() => {
              if (back) {
                void navigate(back, { state: backRouteState });
              } else if (handleClickBack) {
                handleClickBack();
              }
            }}
            css={{
              fontSize: '18px',
              borderRadius: '30px',
              '.MuiButton-label': {
                fontWeight: 500,
              },
              '&:hover': {
                borderWidth: '2px',
              },
            }}
          >
            {Boolean(backLabel)
              ? backLabel
              : content.get('REUSABLE_BUTTON_BACK')}
          </Buttons>
        </Grid>
      )}
      {next && (
        <Grid
          item
          xs={back || handleClickBack ? 6 : isCancel ? 6 : 12}
          md={back || handleClickBack ? 3 : isCancel ? 3 : 6}
        >
          <Buttons
            type="submit"
            fullWidth
            variant="contained"
            disabled={disable}
            css={{
              fontSize: '18px',
              borderRadius: '30px',
              '.MuiButton-label': {
                fontWeight: 500,
              },
            }}
          >
            {Boolean(nextLabel)
              ? nextLabel
              : content.get('REUSABLE_BUTTON_NEXT')}
          </Buttons>
        </Grid>
      )}
    </Grid>
  );
};

export default ProceedOrCancelButton;
